import { Injectable, Injector } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Title, Meta } from '@angular/platform-browser';
import { SeoService } from '../adapters/seo.service';
import { from } from 'rxjs';
import 'rxjs/Rx';
import { setStorage } from '../core/utilities';

import { BaseComponents } from '../base.component';

@Injectable({
  providedIn: 'root'
})
export class UrlGtmGuard extends BaseComponents  {
  seoData: any = {};
  pathKey = "";
  nextPath = "";
  constructor(
    protected injectorObj:Injector,
    private titleService: Title,
    private seo: SeoService
  ) {
    super(injectorObj);
    // console.log('this is contructor');
    this.getTitle();
  }

  // getToken():Observable<any>{
  //   return this.seo.getTitle(path_url);
  // }

  setProductPath(product_data, path_url) {
    if (product_data && product_data.status == true && (typeof product_data.data == 'string')) {

      const thisData = {
        data: {

        }
      };
      thisData.data[this.pathKey] = {
        header: {
          title: product_data.data
        }
      };
      if (this.seoData && this.seoData.data) {
        this.seoData.data = {
          ...this.seoData.data,
          ...thisData.data
        }
      } else {
        this.seoData.data = thisData.data;
      }
      // console.log("ข้อมูลก่อนใส่", thisData);
      // console.log("เซ็ตไตเติ้ล", product_data.data);
      // console.log("ข้อมูล", this.seoData);
      this.setTitle(this.pathKey, 'products');
    } else if (typeof product_data.data == 'object') {
      try {
        //console.log(this.seoData);
        const thisData = {
          data: {

          }
        };
        //console.log("ไม่พบข้อมูล พาท", path_url);
        thisData.data[this.pathKey] = {
          header: {
            title: this.seoData.data['products'].header.title
          }
        };
        if (this.seoData && this.seoData.data) {
          this.seoData.data = {
            ...this.seoData.data,
            ...thisData.data
          }
        } else {
          this.seoData.data = thisData.data;
        }
        this.setTitle(this.pathKey, 'products');
      } catch (err) {
        //console.log("ไม่พบข้อมูล พาท", path_url);
      }
      
    }
  }

  async getTitle(path_url = "") {
    if (path_url) {
      const product_data: any = await this.seo.getTitle(path_url);
      //console.log("รับข้อมูล พาท", path_url);
      this.setProductPath(product_data, path_url);
    } else {
      const seo_data: any = await this.seo.getTitle();
      if (this.seoData && this.seoData.data) {
        this.seoData.data = {
          ...this.seoData.data,
          ...seo_data.data
        }
      } else {
        this.seoData.data = seo_data.data;
      }
      const title = this.nextPath.split("/");
      if (title.length > 2) {
        this.setTitle(this.pathKey);
      } else if (title.length == 2) {
        this.setTitle(title[1]);
      }
    }

  }
  isFixPath(url) {
    console.log(url);
    const url_obj = new URL(url);
    
    return false;
  }
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    
    //console.log('url',state.url);
    let [urlpath, str] = ('' + state.url).split('?');
    let pairs: any = ('' + str).split('&');
    let queryParams: any = {};
    pairs.forEach(function (pair) {
      pair = pair.split('=');
      var name = pair[0]
      var value = pair[1]
      if (name.length)
        if (queryParams[name] !== undefined) {
          if (!queryParams[name].push) {
            queryParams[name] = [queryParams[name]];
          }
          queryParams[name].push(value || '');
        } else {
          queryParams[name] = value || '';
        }
    });

    //console.log('queryParams',queryParams)

    if(queryParams['utm_source'] || 
    queryParams['utm_medium'] || 
    queryParams['utm_campaign'] || 
    queryParams['utm_term'] || 
    queryParams['utm_content']){
      const utm_params = {
        utm_source: queryParams['utm_source']||null,
        utm_medium: queryParams['utm_medium']||null,
        utm_campaign: queryParams['utm_campaign']||null,
        utm_term: queryParams['utm_term']||null,
        utm_content: queryParams['utm_content']||null,
      }
      setStorage('utm_params',utm_params);
      //console.log('utm_params',utm_params)
    }
    

    const title = state.url.split("/");
    let is_set = false;
    const blog_link_data = state.url.split("/").join("[s]");
    this.pathKey = blog_link_data;
    this.nextPath = state.url;
    try {
      if (title.length == 2) {
        this.setTitle(title[1]);
      } else if (title[1] == 'buy-insurance' || title[1] == 'form' ) {
        this.setTitle(title[1]);
      } else if (title[1] == 'blog') {
        is_set = this.setTitle(blog_link_data);
      } else if (title[1] == 'products' || title[1] == 'product') {
        //console.log("คีย์ข้อมูล", blog_link_data);
        //console.log("ข้อมูล", this.seoData);
        if (this.seoData.data && this.seoData.data[blog_link_data]) {
          this.titleService.setTitle(this.seoData.data[blog_link_data].header.title);
        } else {
          // console.log('get title', state.url);
          const observable = from(this.seo.getTitle(state.url));
          return observable.map((data: any) => {
            //console.log('ข้อมูลใน promise');
            //console.log(data);
            this.setProductPath(data, state.url);
            return true;
          });
        }
      }
    } catch (err) {
      //console.log(err);
    }
    // if (this.seoData && this.seoData.data && (!this.seoData.data[blog_link_data])) {
    //   console.log("เซตข้อมูล");
    //   this.setTitle(blog_link_data);
    // }
    return true;
  }

  setTitle(title, type = '') {
    try {
      //console.log("คีย์ดาต้า", title);
      if (this.seoData) {
        const title_obj = this.nextPath.split('?')[0].split("/");
        //console.log((title_obj.length == 2 && title_obj[1] == 'products'));
        
        if ((title_obj.length == 2 && title_obj[1] == 'products') || title_obj[1] != 'products') {
          //console.log('case 2');
          // console.log(title_obj[1]);
          //console.log(this.seoData);
          if (this.seoData.data && this.seoData.data[title]) {
            this.titleService.setTitle(this.seoData.data[title].header.title);
          } else {
            this.titleService.setTitle(this.seoData.data[title_obj[1]].header.title);
          }
        } else if (type == 'products') {
          //console.log('case 1');
          //console.log(this.seoData);
          this.titleService.setTitle(this.seoData.data[title].header.title);
        } else {
          //console.log('case 3');
          //console.log(this.seoData.data[title]);
          if (this.seoData.data[title]) {
            this.titleService.setTitle(this.seoData.data[title].header.title);
          } else {
            this.titleService.setTitle(this.seoData.data[title_obj[1]].header.title);
          }
        }
        return true;
      }
    } catch (err) {
      //console.log(err);
    }
    return true;
  }
}
